import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { ExtrasService } from '../extras.service';

class ExtraItemCard {

    public static $inject = [ 'extrasService', '$localStorage'];

    public countryID: number;

    constructor(
        private extrasService: ExtrasService,
        private $localStorage: ngStorage.StorageService
    ) {
    }

    $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public getImage(imageID: string) {
        return this.extrasService.getExtraImageUrl(imageID);
    }
}

angular.module('naut').component('extraItemCard', {
    template: require('./extra-item-card.component.html'),
    controller: ExtraItemCard,
    controllerAs: 'ctrl',
    bindings: {
        itemId: '<',
        itemTitle: '<',
        price: '<',
        imageId: '<',
        isArchived: '<',
        sku: '<',
        onEdit: '&',
        onDelete: '&',
        onRestore: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/extra-item-card/extra-item-card.component.ts